<template>
    <validation-observer ref="simpleRules">
      <b-tabs
          pills
          fill
      >
        <b-tab active>
          <template #title>
            <feather-icon icon="InfoIcon" />
            <span>Genel</span>
          </template>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <title-text />
        </b-col>
        <b-col cols="12">
          <summary-text />
        </b-col>
        <b-col cols="12">
          <content-text />
        </b-col>
      </b-row>
      <video-embed />
    </b-card>
    <image-card-head />
    <image-card />
    <image-card2 />
    <photo-gallery />
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="InfoIcon" />
            <span>Ürün İçerikleri</span>
          </template>
          <items-card />
        </b-tab>
      </b-tabs>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
    </validation-observer>
</template>

<script>
import {
  BCard, BCol, BRow, BButton, BTabs, BTab,
} from 'bootstrap-vue'

import TitleText from '@/views/Admin/Collections/elements/Title.vue'
import SummaryText from '@/views/Admin/Collections/elements/Summary.vue'
import ContentText from '@/views/Admin/Collections/elements/Content.vue'
import ImageCard from '@/views/Admin/Collections/elements/Image.vue'
import ImageCardHead from '@/views/Admin/Collections/elements/ImageHead.vue'
import ImageCard2 from '@/views/Admin/Collections/elements/Image2.vue'
import PhotoGallery from '@/views/Admin/Collections/elements/PhotoGallery.vue'
import ItemsCard from "@/views/Admin/Collections/elements/itemsCard.vue";
import {ValidationObserver} from "vee-validate";
import { required } from '@validations'
import VideoEmbed from "@/views/Admin/Collections/elements/VideoEmbed.vue";
export default {
  name: 'ItemForm',
  components: {
    VideoEmbed,
    ItemsCard,
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    SummaryText,
    ContentText,
    ImageCard,
    PhotoGallery,
    ImageCard2,
    ImageCardHead,
    ValidationObserver
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['collections/dataItem']
    },
  },
}
</script>
